import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-table-qr-button',
  templateUrl: './table-qr-button.component.html',
  styleUrls: ['./table-qr-button.component.css'],
  standalone: false
})
export class TableQrButtonComponent {
  @Input()
    imageSrc!: string;
    @Input()
    tooltip!: string;
    @Input() color: string = 'primary';
    @Output() buttonClick = new EventEmitter<void>();

    onClick() {
      this.buttonClick.emit();
    }
}
